<app-standard-bottom-sheet [isOpen]="visible()"
                          [isFullScreen]="true"
                          [preventOverlayClose]="isSaving()"
                          [backgroundClass]="slideIn() ? 'add-area-sheet-slide' : ''"
                          (isOpenChange)="onSheetOpenChange($event)"
                          (overlayClick)="onCancel()"
                          testId="job-areas-modal-add-room">

  <div class="add-area-slide"
       [class.slide-in]="slideIn()"
       [class.open]="slideOpen()">
    <app-section-header title="Add a Room"
                        [subtitle]="zoneName()"
                        align="center"
                        [showBack]="slideIn()"
                        (back)="onCancel()"
                        testId="add-area-dialog" />

    <form [formGroup]="form"
          class="add-area-form">

      @if (showZoneSelector()) {
        <app-form-field label="Room Location"
                        [required]="true"
                        [control]="form.controls.zoneId"
                        [errorMessages]="{ required: 'Room location is required.' }"
                        testId="add-area-zone">
          <app-horizontal-button-group [buttons]="zoneButtons()"
                                       testId="add-area-zone-buttons" />
        </app-form-field>
      }

      <app-form-field label="Room Type"
                      [required]="true"
                      [control]="form.controls.areaConfigId"
                      [errorMessages]="{ required: 'Room type is required.' }"
                      testId="add-area-room-type">
        <div class="radiobuttons-container"
             data-testid="radiobuttons-container">
          @if (sortedAreasConfig() === undefined) {
            @for (placeholder of [1, 2, 3, 4, 5]; track placeholder) {
              <p-skeleton height="44px"
                          borderRadius="4px" />
            }
          }
          @for (area of sortedAreasConfig(); track area.id) {
            <div class="area-radio-button-container"
                 (click)="selectArea(area)">
              <p-radiobutton data-testid="add-area-radiobutton"
                             styleClass="bqa-radiobutton"
                             name="areaConfigId"
                             [value]="area.id"
                             formControlName="areaConfigId"
                             [inputId]="'add-area-' + area.id" />
              <label data-testid="add-area-label"
                     [for]="'add-area-' + area.id"
                     class="add-area-label">{{ area.name }}</label>
            </div>
          }
        </div>
      </app-form-field>

      <app-form-field label="Room Name"
                      inputId="add-area-name-input"
                      [required]="true"
                      [invalid]="form.controls.name.invalid && form.controls.name.dirty"
                      hint="e.g., &quot;Main Kitchen&quot; or &quot;Outside Kitchen&quot;"
                      testId="add-area-room-name">
        <input id="add-area-name-input"
               formControlName="name"
               class="area-name-input"
               data-testid="area-name-input">
        @if (form.controls.name.invalid && form.controls.name.dirty) {
          <p class="area-name-error"
             data-testid="room-name-validation">{{ nameErrorText() }}</p>
        }
      </app-form-field>
    </form>

    <app-horizontal-button-group [buttons]="footerButtons()"
                                 class="add-area-footer"
                                 testId="add-area-dialog-footer" />
  </div>
</app-standard-bottom-sheet>
